import { ErpTransferState } from 'models/erp-transfer-statistic'
import { ActionReducer, makeReducer, Reducers } from 'shared-components/src/utils/make-reducer'
import {
    ACTION_LOAD_ERP_TRANSFER_STATISTICS_SUCCESS,
    ACTION_SET_ERP_TRANSFER_STATISTICS_FINISHED_SUCCESS,
    ACTION_SET_ERROR_SNACKBAR_OPEN,
    ACTION_SET_SEND_TO_ERP_RUNNING,
} from './erp-statistic-actions'

type ErpTransferStatisticReducer = ActionReducer<ErpTransferState>

const loadErpTransferStatisticsSuccess: ErpTransferStatisticReducer = (state, action) => {
    const sendToErpRunning =
        !state.sendToErpRunning && action.statistics.some((x) => x.isInProgress) ? true : state.sendToErpRunning

    return {
        ...state,
        erpTransferStatisticLines: action.statistics,
        sendToErpRunning: sendToErpRunning,
    }
}

const setErpTransferFinishedSuccess: ErpTransferStatisticReducer = (state, action) => {
    const lines = state.erpTransferStatisticLines.map((line) => {
        if (line.id === action.statistics.id) {
            return action.statistics
        } else {
            return line
        }
    })

    return {
        ...state,
        erpTransferStatisticLines: lines,
    }
}

const setErrorSnackbarOpen: ErpTransferStatisticReducer = (state, action) => {
    return {
        ...state,
        showSnackbarError: action.open,
    }
}

const setSendToErpRunning: ErpTransferStatisticReducer = (state, action) => {
    return {
        ...state,
        sendToErpRunning: action.sendToErpRunning,
    }
}

const reducers: Reducers<ErpTransferState> = {
    [ACTION_LOAD_ERP_TRANSFER_STATISTICS_SUCCESS]: loadErpTransferStatisticsSuccess,
    [ACTION_SET_ERP_TRANSFER_STATISTICS_FINISHED_SUCCESS]: setErpTransferFinishedSuccess,
    [ACTION_SET_ERROR_SNACKBAR_OPEN]: setErrorSnackbarOpen,
    [ACTION_SET_SEND_TO_ERP_RUNNING]: setSendToErpRunning,
}

const initialState = {
    erpTransferStatisticLines: [],
    showSnackbarError: true,
    sendToErpRunning: false,
}

export const erpTransferStatisticReducer = makeReducer<ErpTransferState>(reducers, initialState)
